import api from "../../core/api";
import { Country } from "../models/CommonModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.commonApiBaseUrl };
}

export function getCountries(): Promise<Country[]> {
  return api.get<Country[]>(`/v1/countries`, getRequestConfig()).then(x => x.data);
}
